import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_PROTHEUS_BASE_URL
});

export const apiSignIn = async (form) => {

    const token = `${form.user}:${form.password}`;
    const encodedToken = Buffer.from(token).toString('base64');

    const config = {
        method: 'post',
        url: process.env.REACT_APP_PROTHEUS_AUTH_PATH,
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${form.company.id}` }
    };

    const response = await api(config);

    return response;

};

export const apiFetchOpenedServiceRequest = async (encodedToken, auth) => {

    const config = {
        method: 'get',
        url: process.env.REACT_APP_PROTHEUS_GET_OPEN_RS_PATH,
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
    };

    const response = await api(config);

    response.data.items = response.data.items.map((item) => ({
        ...item,
        status: item.status.includes('Aguardando')
            ? 'Aguardando Análise'
            : item.status.includes('Distribu')
            ? 'Distribuída'
            : item.status,
    }));

    return response;

};

export const apiFetchRequestService = async (encodedToken, auth) => {

    const config = {
        method: 'get',
        url: process.env.REACT_APP_PROTHEUS_GET_RS_PATH,
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
    };

    const response = await api(config);

    return response;

};

export const apiFetchAssets = async (encodedToken, auth) => {

    const config = {
        method: 'get',
        url: process.env.REACT_APP_PROTHEUS_GET_ASSETS_PATH,
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
    };

    const response = await api(config);

    return response;

};


export const apiFetchTypesOfService = async (encodedToken, auth) => {

    const config = {
        method: 'get',
        url: process.env.REACT_APP_PROTHEUS_GET_TYPESOFSERVICE_PATH,
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
    };

    const response = await api(config);

    return response;

};

export const apiHandleSaveNewRS = async (form, encodedToken, auth) => {

    const response = await api.post(null, form, {
                        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
                     });
      
    return response;

};

export const apiHandleSaveEvaluation = async (form, encodedToken, auth) => {

    return api.put(`/${form.number}`, form, {
        headers: { 'Authorization': 'Basic '+ encodedToken, 'tenantId': `${auth.company.id}` }
    });

};

export default api;